// Third party
import axios from 'axios';

// Components
import { getAuthHeaders } from '../utils';
import { DEV_APP_API_URL } from '../constants';

export function AnalyticsController() {
  const getScenarioUsage = async <T>(): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/transactions/transactions/history`, {
      headers: getAuthHeaders(),
    });
  };

  return { getScenarioUsage };
}
